import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Home } from '@mui/icons-material';
import { Evaluation, EVALUATION_SCENE } from '../../NominationForm';
import { PAGE_TEXT } from '../../lang';
import { SUPERVISOR_MONITOR_LIST_MODULE } from '../../constant';
import { DRC_ASSESSMENT_MODULE } from '../../../../Assessment';
import { useGetNominationInformation } from '../../../../Assessment/graphql';
import { useAuth } from '../../../../../contexts';
import {
  Alert,
  Button,
  Loading,
  type ROLES_MODULE,
  Stepper,
  type Steps,
} from '../../../../../components';
import { getSimplifyRole, SimplifyRoles } from '../../../../../utils';
import { PolishRefereeReportSelection } from './PolishRefereeReportSelection';

export const PolishEvaluation: React.FunctionComponent = () => {
  const { role } = useAuth();
  const { applicationId = '' } = useParams<{ applicationId: string }>();
  const [activeStep, setActiveStep] = useState<number>(0);
  const {
    scholarshipNomination,
    hasDoneHKPFSRefereeSelection,
    loading: pageLoading,
    error: pageError,
    refetch,
  } = useGetNominationInformation({
    application: { _id: { eq: applicationId } },
  });

  const currentRole = getSimplifyRole(role as ROLES_MODULE);

  const isDorpgs = currentRole === SimplifyRoles.DORPGS;

  const handleBack = (): void => {
    window.location.href = isDorpgs
      ? `/internal/dorpgs-homepage?am=${DRC_ASSESSMENT_MODULE.POLISH_COMMENTS}`
      : `/internal/nominations?am=${SUPERVISOR_MONITOR_LIST_MODULE.POLISH_COMMENTS}`;
  };

  const steps: Steps[] = [
    {
      label: PAGE_TEXT.POLISH_COMMENTS,
      hasDone: true,
      clickableStep: true,
    },
    {
      label: PAGE_TEXT.REFEREE_REPORT_SELECTION,
      clickableStep: true,
      hasDone: hasDoneHKPFSRefereeSelection,
    },
  ];

  const componentsMap: Array<{
    title: string;
    content: React.ReactNode;
  }> = [
    {
      title: PAGE_TEXT.WRITTEN_COMMENTS_REFINE,
      content: (
        <Evaluation
          scene={EVALUATION_SCENE.POLISH_COMMENTS}
          applicationId={applicationId}
          scholarshipNomination={scholarshipNomination}
          refetchEvaluation={refetch}
        />
      ),
    },
    {
      title: PAGE_TEXT.REFEREE_REPORT_SELECTION,
      content: <PolishRefereeReportSelection refetch={refetch} />,
    },
  ];

  if (pageError)
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: 'Error Occurs.' + (pageError as Error)?.message,
          alertType: 'error',
        }}
      />
    );

  return pageLoading ? (
    <Loading />
  ) : (
    <div className="px-6">
      <Button
        variant="outlined"
        onClick={handleBack}
        size="medium"
        startIcon={<Home />}
        sx={{
          position: 'absolute',
          textTransform: 'none',
          marginTop: '1rem',
        }}
      >
        {PAGE_TEXT.POLISH_LIST}
      </Button>
      <div className="flex flex-row mt-2">
        <div className="flex-1">
          <div className="flex flex-col">
            <div className="text-2xl font-bold mt-6 text-center text-[#951d1d]">
              {componentsMap[activeStep].title}
            </div>
            {componentsMap[activeStep].content}
          </div>
        </div>
        {isDorpgs && (
          <div className="mt-8 ml-4">
            <Stepper
              width={200}
              activeStep={activeStep}
              onChange={index => {
                setActiveStep(index);
              }}
              steps={steps}
            />
          </div>
        )}
      </div>
    </div>
  );
};
